module.exports = __webpack_public_path__ + "img/prize-back.3c182a93.png";